import { Record } from 'immutable';

import {
  SET_TOUR_MODE,
  TOGGLE_CUSTOMER_ONBOARDING_POPUP
} from './actions';

const CustomerOnboardingConfig = new Record({
  visible: false,
  firstTimeVisitor: false,
});

const InitialState = new Record({
  customerOnboardingPopupConfig: new CustomerOnboardingConfig(),
  tourMode: false,
});

export const initialState = new InitialState();

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_TOUR_MODE: {
      return state.set('tourMode', payload.tourMode);
    }
    case TOGGLE_CUSTOMER_ONBOARDING_POPUP: {
      return state
        .setIn(['customerOnboardingPopupConfig', 'visible'], payload.visible)
        .setIn(['customerOnboardingPopupConfig', 'firstTimeVisitor'], payload.firstTimeVisitor);
    }
    default: {
      return state;
    }
  }
};
